// extracted by mini-css-extract-plugin
export var block = "account-menu-module--block--1eFwA";
export var menu = "account-menu-module--menu--FGLpA";
export var menuItem = "account-menu-module--menuItem--3Z0q4";
export var menuLink = "account-menu-module--menuLink--2AeDq";